import React, {
  FC, useEffect, useMemo, useState,
} from 'react';
import key from 'weak-key';
import classNames from 'classnames';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import { Colors, ImageSize, imagesProps } from '@/pages/CareersPage/components/PageHeader/Waterfall/imagesProps';
import styles from './Waterfall.module.scss';

const imageSizeClassNames = {
  [ImageSize.xs]: styles.sizeXS,
  [ImageSize.s]: styles.sizeS,
  [ImageSize.m]: styles.sizeM,
  [ImageSize.l]: styles.sizeL,
};

const imageColorsClassNames = {
  [Colors.white]: styles.white,
  [Colors.grey]: styles.grey,
  [Colors.blue]: styles.blue,
  [Colors.emerald]: styles.emerald,
  [Colors.green]: styles.green,
  [Colors.yellow]: styles.yellow,
  [Colors.orange]: styles.orange,
};

export interface WaterfallProps {
  waterfallUrls?: string[];
}

const Waterfall: FC<WaterfallProps> = ({
  waterfallUrls,
}) => {
  const [isMounted, setIsMounted] = useState(false); // wait with rendering due to animation lags

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const imagesBlock = useMemo(() => {
    if (!waterfallUrls?.length) {
      return null;
    }

    return (
      <div className={styles.content}>
        {waterfallUrls.map((url, index) => {
          const imagePropsIndex = index % imagesProps.length;
          const { size, color, isLogo } = imagesProps[imagePropsIndex];
          const imageSize = size || ImageSize.s;

          return (
            <div
              key={key({ url })}
              className={classNames(
                styles.imageWrapper,
                imageSizeClassNames[imageSize],
                color && imageColorsClassNames[color],
                isLogo && styles.isLogo,
              )}
            >
              <img
                alt=""
                className={styles.image}
                src={url}
              />
            </div>
          );
        })}
      </div>
    );
  }, [waterfallUrls]);

  if (!waterfallUrls?.length || !isMounted) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.scalingContainer}>
        {imagesBlock}
        {imagesBlock}
      </div>
    </div>
  );
};

Waterfall.displayName = 'Waterfall';

export default Waterfall;
